module.exports = __webpack_public_path__ + "static/media/messenger.1f8bc322.png";